import React, { createContext, useState, useContext, useEffect } from "react";
import {
  _get_id_from_localStorage,
  _get_user_from_localStorage,
  get_section_source_id_from_local,
} from "../utils/LocalStorage";
import { useLocation } from "react-router-dom";
import {
  candidate_api_detail_fetch,
  client_detail_api,
} from "../DAL/partner/partners";

const IdsContext = createContext();
const get_id = _get_id_from_localStorage();
const get_source_inside_id = get_section_source_id_from_local();
const get_user = _get_user_from_localStorage();

export const IdsProvider = ({ children }) => {
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const [profileNewImage, setProfileNewImage] = React.useState();
  const [detailDatacontext, setdetaildatacontext] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false); //
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const triggerRefresh = () => setRefreshTrigger((prev) => !prev); // Toggle flag to refresh consumers

  const [ids, setIds] = useState(get_id);
  const [breadCrumb, setBreadCrumb] = useState([]);
  const [userInfo, setUserInfo] = useState(get_user);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [isRefresh, setIsRefresh] = useState(false);
  const [sourceSectionIds, setSourceSectionIds] =
    useState(get_source_inside_id);

  const [findId, setFindId] = useState("");
  const [findIdsSourceInside, setFindIdSourceInside] = useState("");

  const fetchAdminDetail = async () => {
    setLoadingDetails(true);

    try {
      const user_info = JSON.parse(localStorage.getItem("user")) || null;
      if (!user_info) return;

      let response;
      if (user_info.type === 2) {
        response = await client_detail_api(user_info.user_id._id);
      } else if (user_info.type === 1) {
        response = await candidate_api_detail_fetch(user_info.user_id._id);
      }

      if (response?.code === 200) {
        setdetaildatacontext(response.organization || response.customer);
      }
    } catch (error) {
      console.error("Error fetching admin details:", error);
    }

    setLoadingDetails(false);
  };

  useEffect(() => {
    fetchAdminDetail();
  }, []);

  useEffect(() => {
    if (ids && Array.isArray(ids)) {
      const matchedItem = ids.find((item) => item.path === `/${firstSegment}`);
      setFindId(matchedItem ? matchedItem._id : "");
    }
  }, [firstSegment, ids]);
  useEffect(() => {
    if (sourceSectionIds && Array.isArray(sourceSectionIds)) {
      const matchedItem = sourceSectionIds.find(
        (item) => item.path === `/${firstSegment}`
      );
      setFindIdSourceInside(matchedItem ? matchedItem._id : "");
    }
  }, [firstSegment, sourceSectionIds]);

  useEffect(() => {
    setProfileNewImage(localStorage.getItem("image"));
  }, [localStorage.getItem("image")]);

  return (
    <IdsContext.Provider
      value={{
        ids,
        setIds,
        findId,
        breadCrumb,
        setBreadCrumb,
        userInfo,
        setUserInfo,
        setProfileNewImage,
        profileNewImage,
        detailDatacontext,
        fetchAdminDetail,
        loadingDetail,
        setSourceSectionIds,
        sourceSectionIds,
        setFindIdSourceInside,
        findIdsSourceInside,
        isRefresh,
        setIsRefresh,
      }}
    >
      {children}
    </IdsContext.Provider>
  );
};

export const useIds = () => useContext(IdsContext);
